// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__L-J14","footerLogo":"Footer_footerLogo__QC6br"};